<template>
  <div class="navigator">
    <router-link
      :to="{
        name: 'FAQView',
        params: {
          tenant_uuid: router.currentRoute.value.params.tenant_uuid,
          insuree_uuid: router.currentRoute.value.params.insuree_uuid,
        },
      }"
      class="navigator-link info-text-list-bold">
      <div class="navigator-link-icon" v-html="icons.faq"></div>
      FAQ
    </router-link>
    <router-link
      :to="{
        name: 'ContactView',
        params: {
          tenant_uuid: router.currentRoute.value.params.tenant_uuid,
          insuree_uuid: router.currentRoute.value.params.insuree_uuid,
        },
      }"
      class="navigator-link info-text-list-bold">
      <div class="navigator-link-icon" v-html="icons.callIcon"></div>
      Contact
    </router-link>
    <div class="navigator-link">
      <div class="navigator-link-policy-box">
        <router-link
          :to="{
            name: 'PolicyView',
            params: {
              tenant_uuid: router.currentRoute.value.params.tenant_uuid,
              insuree_uuid: router.currentRoute.value.params.insuree_uuid,
            },
          }"
          class="navigator-link-policy">
          <div class="navigator-link-icon" v-html="icons.policyIcon"></div>
        </router-link>
      </div>
    </div>
    <router-link
      :to="{
        name: 'ActivityView',
        params: {
          tenant_uuid: router.currentRoute.value.params.tenant_uuid,
          insuree_uuid: router.currentRoute.value.params.insuree_uuid,
        },
      }"
      class="navigator-link info-text-list-bold">
      <div class="navigator-link-icon" v-html="icons.securityIcon"></div>
      Activity
    </router-link>
    <router-link
      :to="{
        name: 'MenuView',
        params: {
          tenant_uuid: router.currentRoute.value.params.tenant_uuid,
          insuree_uuid: router.currentRoute.value.params.insuree_uuid,
        },
      }"
      class="navigator-link info-text-list-bold">
      <div class="navigator-burger">
        <div class="navigator-burger-line"></div>
        <div class="navigator-burger-line"></div>
        <div class="navigator-burger-line"></div>
      </div>
      More
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import icons from '@/icons';
const router = useRouter();
</script>
